import React from "react";
import { Modal } from "react-bootstrap";

const MoveMultipleJobServicesModal = ({
  show,
  onHide,
  jobServices,
  onConfirm,
  onCancel
}) => {
  const handleJobServiceClick = (jobId, jobServiceId) => {
    window.open(`/jobs/${jobId}/job_services/${jobServiceId}`, "_blank");
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <h2 className="modal-title">Move Multiple Job Services</h2>
        </Modal.Title>
      </Modal.Header>
      <div className="modal-body px-md-5">
        <p>
          We have detected {jobServices.length} other Job Service{jobServices.length > 1 ? "s" : ""} at the same address and time:
        </p>
        <ul className="mb-3" style={{ listStyle: "none", paddingLeft: 0 }}>
          {jobServices.map((js) => (
            <li key={js.job_service_id} style={{ marginBottom: "8px" }}>
              <button
                type="button"
                onClick={() => handleJobServiceClick(js.job_id, js.job_service_id)}
                style={{
                  background: "none",
                  border: "none",
                  color: "#007bff",
                  cursor: "pointer",
                  padding: 0,
                  textDecoration: "underline",
                  textAlign: "left"
                }}
                onMouseEnter={(e) => { e.target.style.color = "#0056b3"; }}
                onMouseLeave={(e) => { e.target.style.color = "#007bff"; }}>
                {js.job_no} - {js.product_name}
              </button>
            </li>
          ))}
        </ul>
        <p>Do you want to move them all to the new time?</p>
      </div>
      <div className="modal-footer d-flex justify-content-end p-4">
        <button
          className="btn btn-link btn-lg"
          onClick={onCancel}
          type="button">
          No, move only current job
        </button>
        <button
          className="btn btn-red btn-lg"
          onClick={onConfirm}
          type="button">
          Yes, move all
        </button>
      </div>
    </Modal>
  );
};

export default MoveMultipleJobServicesModal;
